"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACMDomainNamePattern = void 0;
exports.ACMDomainNamePattern = new RegExp(/^(\*\.)?(((?!-)[A-Za-z0-9-]{0,62}[A-Za-z0-9])\.)+([A-Za-z0-9]{1,62}[A-Za-z0-9])$/);
